// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"47efa94d","898":"27e8458e"}[chunkId] + ".chunk.js";
};